import React, {Component} from 'react';

import {Edit} from 'components/detail';
import {SimpleForm} from 'components/form';

import {MultipleChoicesFromDataInput, TextInput} from 'components/input';

import {
    DisabledInputOptions,
} from 'util/constants';

import PropTypes from "prop-types";
import {connect} from "react-redux";
import {crudGetMeta as crudGetMetaAction} from "../../actions";
import {change as changeAction} from "redux-form";


class DisableEmailBase extends Component {

    static propTypes = {
        crudGetMeta: PropTypes.func.isRequired,
        changeForm: PropTypes.func.isRequired,
    };

    componentDidMount() {
    }

    handleSubmit() {
        console.log()
    }

    render() {
        return (
            <Edit {...this.props}>
                <SimpleForm>
                    <TextInput options={DisabledInputOptions} source="shop_id" label="Shop ID"/>
                    <TextInput options={DisabledInputOptions} source="shop_name" label="Shop Name"/>
                    <TextInput options={DisabledInputOptions} source="owner_mobile" label="Owner Mobile"/>
                    <MultipleChoicesFromDataInput
                        label="Email"
                        source="sending_emails"
                        choiceSource="emails"
                        optionText="email"
                        optionValue="email"
                    />
                </SimpleForm>
            </Edit>
        );
    }
}

const mapStateToProps = (state, props) => ({});

export const DisableEmail = connect(
    mapStateToProps,
    {
        crudGetMeta: crudGetMetaAction,
        changeForm: changeAction,
    }
)(DisableEmailBase);


// WEBPACK FOOTER //
// ./src/routes/shop/DisableEmail.js